// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General form container */
.form-container {
    font-family: Arial, sans-serif;
    max-width: 700px;
    margin: 0 auto;
    padding: 30px;
  }
  
  /* Header */
  .form-container h1 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  /* Required note */
  .form-container .note {
    font-size: 14px;
    margin-bottom: 20px;
  }
  
  /* Form group spacing */
  .form-group {
    margin-bottom: 25px;
  }
  
  /* Labels */
  label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  /* Select box */
  select {
    width: 100%;
    padding: 10px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  /* Input group with dollar sign */
  .input-group {
    display: flex;
    align-items: center;
  }
  
  .input-group span {
    background-color: #f5f5f5;
    padding: 10px 14px;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
  }
  
  .input-group input {
    flex: 1 1;
    padding: 10px 14px;
    border: 1px solid #ccc;
    /* border-left: none; */
    border-radius: 0 4px 4px 0;
    font-size: 16px;
    display: block;
  }
  
  /* Radio buttons */
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .radio-group label {
    display: flex;
    align-items: center;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s;
  }
  
  .radio-group input[type="radio"] {
    margin-right: 12px;
  }
  
  /* Info box */
  .info-box {
    background-color: #e8f4ff;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 4px;
    border-left: 4px solid #0066cc;
  }

  .info-box h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1rem;
    color: #0066cc;
  }

  .info-box p {
    margin: 0;
    font-size: 0.9rem;
  }

  .info-box a {
    color: #4a90e2;
    text-decoration: underline;
  }

  /* Residency options container */
.residency-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* Hide the default radio button but keep it interactive */
.residency-option input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  
  /* Ensure the entire residency option is clickable */
  .residency-option {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #f9f9f9;
    position: relative; /* Required for the hidden input */
  }
  
  .residency-option.selected {
    border-color: #007bff;
    background-color: #e9f5ff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  
  /* Label styling */
  .residency-option label {
    margin: 0;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    flex: 1 1; /* Makes the label take up the full width of the option */
  }
  
  /* Hover effect */
  .residency-option:hover {
    border-color: #007bff;
    background-color: #f0f8ff;
  }
/* Submit button styling */
button[type="submit"] {
    display: block;
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #2895eb;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
  }
  
  button[type="submit"]:hover {
    background-color: #0056b3;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  button[type="submit"]:active {
    background-color: #004494;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  button[type="submit"]:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }

  .form-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 20px;
    display: inline-block;
  }
  
  .help-link {
    float: right;
    color: #0066cc;
    cursor: pointer;
  }
  
  .help-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #0066cc;
    border-radius: 50%;
    text-align: center;
    margin-left: 5px;
  }
  
  .form-group {
    margin-bottom: 24px;
  }
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .form-control {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .radio-group, .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .radio-option, .checkbox-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  input[type="radio"],
  input[type="checkbox"] {
    margin-right: 8px;
  }
  
  /* Add hover effect */
  .radio-option:hover,
  .checkbox-option:hover {
    background-color: #f8f9fa;
  }

/* Submit group styling */
.submit-group {
  margin-top: 2rem;
}

.submit-button {
  background-color: #0066cc;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: #0052a3;
}

.submit-button:active {
  background-color: #004080;
}

.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .checkbox-item {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .checkbox-item input[type="checkbox"] {
    margin-top: 0.25rem;
  }
  
  .checkbox-item label {
    font-weight: normal;
    line-height: 1.4;
  }

/* Add these styles to your CSS file */
.income-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.income-record {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.input-with-prefix {
  display: flex;
  align-items: center;
}

.input-with-prefix span {
  padding: 0.5rem;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-right: none;
  border-radius: 4px 0 0 4px;
}

.input-with-prefix input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0 4px 4px 0;
}

.add-button {
  background-color: #007bff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 1rem 0;
}

.add-button:hover {
  background-color: #0056b3;
}

.totals-section {
  margin-top: 2rem;
}

.totals-section table {
  width: 100%;
  border-collapse: collapse;
}

.totals-section th,
.totals-section td {
  padding: 0.5rem;
  text-align: right;
  border: 1px solid #ddd;
}

.totals-section th {
  background-color: #f0f0f0;
}

.totals-section table td:first-child {
  text-align: left;
  padding-right: 1rem;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #5a6268;
}

.income-form {
  margin-top: 1rem;
}

.income-tests-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.income-tests-record {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.spouse-details-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.spouse-details-record {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.tax-offsets-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.tax-offsets-record {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.other-amounts-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.other-amounts-record {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.info-link {
  margin-top: 0.5rem;
  font-size: 0.9rem;
}

.info-link a {
  color: #0066cc;
  text-decoration: none;
}

.info-link a:hover {
  text-decoration: underline;
}

.medicare-section {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.policy-accordion {
  margin: 1rem 0;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.policy-accordion summary {
  padding: 1rem;
  cursor: pointer;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.policy-details {
  padding: 1rem;
  background-color: white;
}

.policy-actions {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
}

.policy-form {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.radio-group {
  display: flex;
  gap: 2rem;
}

.info-text {
  font-size: 0.9rem;
  color: #666;
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/agent/incometaxcalculator.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA,WAAW;EACX;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;IACf,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,aAAa;EACb;IACE,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA,gCAAgC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,0DAA0D;AAC5D;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;EACtB;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA,kBAAkB;EAClB;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,SAAO,EAAE,yDAAyD;EACpE;;EAEA,iBAAiB;EACjB;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;AACF,0BAA0B;AAC1B;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,4DAA4D;EAC9D;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;;IAEE,yBAAyB;EAC3B;;AAEF,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;AAEF,sCAAsC;AACtC;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* General form container */\n.form-container {\n    font-family: Arial, sans-serif;\n    max-width: 700px;\n    margin: 0 auto;\n    padding: 30px;\n  }\n  \n  /* Header */\n  .form-container h1 {\n    font-size: 32px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  /* Required note */\n  .form-container .note {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  \n  /* Form group spacing */\n  .form-group {\n    margin-bottom: 25px;\n  }\n  \n  /* Labels */\n  label {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 8px;\n  }\n  \n  /* Select box */\n  select {\n    width: 100%;\n    padding: 10px 12px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  /* Input group with dollar sign */\n  .input-group {\n    display: flex;\n    align-items: center;\n  }\n  \n  .input-group span {\n    background-color: #f5f5f5;\n    padding: 10px 14px;\n    border: 1px solid #ccc;\n    border-right: none;\n    border-radius: 4px 0 0 4px;\n    font-size: 16px;\n  }\n  \n  .input-group input {\n    flex: 1;\n    padding: 10px 14px;\n    border: 1px solid #ccc;\n    /* border-left: none; */\n    border-radius: 0 4px 4px 0;\n    font-size: 16px;\n    display: block;\n  }\n  \n  /* Radio buttons */\n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .radio-group label {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: border-color 0.2s;\n  }\n  \n  .radio-group input[type=\"radio\"] {\n    margin-right: 12px;\n  }\n  \n  /* Info box */\n  .info-box {\n    background-color: #e8f4ff;\n    padding: 1rem;\n    margin: 1rem 0;\n    border-radius: 4px;\n    border-left: 4px solid #0066cc;\n  }\n\n  .info-box h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n    color: #0066cc;\n  }\n\n  .info-box p {\n    margin: 0;\n    font-size: 0.9rem;\n  }\n\n  .info-box a {\n    color: #4a90e2;\n    text-decoration: underline;\n  }\n\n  /* Residency options container */\n.residency-options {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  /* Hide the default radio button but keep it interactive */\n.residency-option input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n  \n  /* Ensure the entire residency option is clickable */\n  .residency-option {\n    display: flex;\n    align-items: center;\n    padding: 10px 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background-color: #f9f9f9;\n    position: relative; /* Required for the hidden input */\n  }\n  \n  .residency-option.selected {\n    border-color: #007bff;\n    background-color: #e9f5ff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n  }\n  \n  /* Label styling */\n  .residency-option label {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n    cursor: pointer;\n    flex: 1; /* Makes the label take up the full width of the option */\n  }\n  \n  /* Hover effect */\n  .residency-option:hover {\n    border-color: #007bff;\n    background-color: #f0f8ff;\n  }\n/* Submit button styling */\nbutton[type=\"submit\"] {\n    display: block;\n    width: 100%;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #fff;\n    background-color: #2895eb;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  button[type=\"submit\"]:hover {\n    background-color: #0056b3;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  button[type=\"submit\"]:active {\n    background-color: #004494;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  button[type=\"submit\"]:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n\n  .form-container {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n  \n  h1 {\n    font-size: 24px;\n    margin-bottom: 20px;\n    display: inline-block;\n  }\n  \n  .help-link {\n    float: right;\n    color: #0066cc;\n    cursor: pointer;\n  }\n  \n  .help-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #0066cc;\n    border-radius: 50%;\n    text-align: center;\n    margin-left: 5px;\n  }\n  \n  .form-group {\n    margin-bottom: 24px;\n  }\n  \n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n  }\n  \n  .form-control {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  .radio-group, .checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .radio-option, .checkbox-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  \n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-right: 8px;\n  }\n  \n  /* Add hover effect */\n  .radio-option:hover,\n  .checkbox-option:hover {\n    background-color: #f8f9fa;\n  }\n\n/* Submit group styling */\n.submit-group {\n  margin-top: 2rem;\n}\n\n.submit-button {\n  background-color: #0066cc;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.submit-button:hover {\n  background-color: #0052a3;\n}\n\n.submit-button:active {\n  background-color: #004080;\n}\n\n.checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n  \n  .checkbox-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .checkbox-item input[type=\"checkbox\"] {\n    margin-top: 0.25rem;\n  }\n  \n  .checkbox-item label {\n    font-weight: normal;\n    line-height: 1.4;\n  }\n\n/* Add these styles to your CSS file */\n.income-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.income-record {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.input-with-prefix {\n  display: flex;\n  align-items: center;\n}\n\n.input-with-prefix span {\n  padding: 0.5rem;\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-right: none;\n  border-radius: 4px 0 0 4px;\n}\n\n.input-with-prefix input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 0 4px 4px 0;\n}\n\n.add-button {\n  background-color: #007bff;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 1rem 0;\n}\n\n.add-button:hover {\n  background-color: #0056b3;\n}\n\n.totals-section {\n  margin-top: 2rem;\n}\n\n.totals-section table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.totals-section th,\n.totals-section td {\n  padding: 0.5rem;\n  text-align: right;\n  border: 1px solid #ddd;\n}\n\n.totals-section th {\n  background-color: #f0f0f0;\n}\n\n.totals-section table td:first-child {\n  text-align: left;\n  padding-right: 1rem;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.cancel-button {\n  background-color: #6c757d;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: #5a6268;\n}\n\n.income-form {\n  margin-top: 1rem;\n}\n\n.income-tests-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.income-tests-record {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.spouse-details-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.spouse-details-record {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.tax-offsets-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.tax-offsets-record {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.other-amounts-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.other-amounts-record {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.info-link {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.info-link a {\n  color: #0066cc;\n  text-decoration: none;\n}\n\n.info-link a:hover {\n  text-decoration: underline;\n}\n\n.medicare-section {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.policy-accordion {\n  margin: 1rem 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.policy-accordion summary {\n  padding: 1rem;\n  cursor: pointer;\n  background-color: #f8f8f8;\n  border-radius: 4px;\n}\n\n.policy-details {\n  padding: 1rem;\n  background-color: white;\n}\n\n.policy-actions {\n  margin-top: 1rem;\n  display: flex;\n  gap: 1rem;\n}\n\n.policy-form {\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.radio-group {\n  display: flex;\n  gap: 2rem;\n}\n\n.info-text {\n  font-size: 0.9rem;\n  color: #666;\n  margin-top: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
